__turbopack_context__.v({
  "actions": "ParagraphProductCta-module__-dSRmW__actions",
  "badge": "ParagraphProductCta-module__-dSRmW__badge",
  "btnGhost": "ParagraphProductCta-module__-dSRmW__btnGhost",
  "btnGhostLabel": "ParagraphProductCta-module__-dSRmW__btnGhostLabel",
  "btnPrimary": "ParagraphProductCta-module__-dSRmW__btnPrimary",
  "btnTag": "ParagraphProductCta-module__-dSRmW__btnTag",
  "content": "ParagraphProductCta-module__-dSRmW__content",
  "desc": "ParagraphProductCta-module__-dSRmW__desc",
  "ghostWrap": "ParagraphProductCta-module__-dSRmW__ghostWrap",
  "image": "ParagraphProductCta-module__-dSRmW__image",
  "section": "ParagraphProductCta-module__-dSRmW__section",
  "title": "ParagraphProductCta-module__-dSRmW__title",
  "tooltip": "ParagraphProductCta-module__-dSRmW__tooltip",
  "tooltipCta": "ParagraphProductCta-module__-dSRmW__tooltipCta",
  "tooltipDesc": "ParagraphProductCta-module__-dSRmW__tooltipDesc",
});
